import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import items from './items';

const adminReports = combineReducers({
  items,
  isLoading: loadingStatusAccordingToReducer('userActivityReportsLoadingStatus'),
});

export default adminReports;



// WEBPACK FOOTER //
// ./src/modules/admin-reports/reducers/admin-reports.reducer.js